/**
 * The download endpoint may return either a URL or a Markdown link whose
 * destination contains Markdown-escaped query-string separators.
 */
export function parseChatDownloadUrl(value: string | null | undefined): string | null {
  let candidate = value?.trim() ?? '';

  if (candidate.startsWith('[')) {
    const destinationStart = candidate.indexOf('](');
    const destinationEnd = candidate.lastIndexOf(')');
    if (destinationStart < 0 || destinationEnd <= destinationStart + 2) return null;
    candidate = candidate.slice(destinationStart + 2, destinationEnd).trim();
  }

  if (candidate.startsWith('<') && candidate.endsWith('>')) {
    candidate = candidate.slice(1, -1).trim();
  }

  // Markdown permits punctuation to be escaped with a backslash. Those
  // backslashes are not part of an Azure SAS URL and invalidate its signature.
  candidate = candidate.replace(/\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, '$1');

  try {
    const url = new URL(candidate);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null;
  } catch {
    return null;
  }
}
